// extracted by mini-css-extract-plugin
export default {"indicator":"CinePlayer-styles-module--indicator--syoHH","container":"CinePlayer-styles-module--container--Zike_"};